export const ADVERTISEMENT_CONTENT = {
  banner: {
    heading: 'Reach Millions of Fans Through the <span class="color-span">Creators</span> They Love!',
    description: 'Advertise with top creators & influencers in fitness, food, music, and more. Boost your brand’s reach effortlessly.',
    button: 'GET STARTED',
    image: 'https://cdn-www.topfans.com/TopFans/Home/1766384945_advertisment_landing_page.png'
  },
  whyAdvertise: {
    title: 'Why Advertise on TopFan?',
    sections: [
      {
        title: 'Highest Return on Investment',
        description: 'Our innovative advertising technology maximizes the efficiency of your advertising budget and delivers results.',
        points: [
          'Lowest CPM fees in the industry',
          'Adjust ad campaigns based on real-time performance',
          'Set your daily budgets and goals'
        ],
        button: 'GET STARTED',
        image: '../../../assets/images/svg/advertisement-2.svg'
      },
      {
        title: 'Advertise with the Perfect Creators for your Brand',
        description: 'TopFan Brand Safe platform allows you to advertise to the fans of thousands of high-quality creators with a single campaign.',
        points: [
          'Associate your brand with top content creators',
          'Reach fans of creators with specific interests',
          'Target based on age, gender and geographic location'
        ],
        button: 'GET STARTED',
        image: 'https://cdn-www.topfans.com/TopFans/Home/1766140293_advertisment_landing.png',
      }
    ]
  },
  ctaBanner: {
    title: 'Ready to Get Started?',
    description: 'Stay ahead of the curve. Advertise on TopFan and leverage the creator economy to help your business thrive.',
    button: 'GET STARTED',
    images: {
      default:
        'https://cdn-www.topfans.com/TopFans/1768820005_ads_home_page_1.png',
      hover: 'https://cdn-www.topfans.com/TopFans/1768820046_ads_home_page_2.png',
    },
  },
  faq: {
    module: 'CREATOR_ONBOARDING',
    heading: 'FAQs'
  },
  categories: {
    heading: 'CONNECT WITH CONTENT CREATORS & FANS WHOSE INTERESTS ALIGN WITH YOUR BRAND:',
    items: [
      {
        name: 'Music',
        icon: 'icon-liteguitar',
        route: 'search-result/hashtag/Music'
      },
      {
        name: 'Sports',
        icon: 'icon-litebetting',
        route: 'search-result/hashtag/Sports'
      },
      {
        name: 'Health & Wellness',
        icon: 'icon-litehealth-insurance',
        route: 'search-result/hashtag/health&wellness'
      },
      {
        name: 'Travel',
        icon: 'icon-litetravel',
        route: 'search-result/hashtag/travel'
      },
      {
        name: 'Beauty & Skincare',
        icon: 'icon-liteskin-care',
        route: 'search-result/hashtag/Beauty & Skincare'
      },
      {
        name: 'Humor',
        icon: 'icon-litetheater-masks',
        route: 'search-result/hashtag/Humor'
      },
      {
        name: 'Television & Movies',
        icon: 'icon-liteFilm_Icon',
        route: 'search-result/hashtag/television&movies'
      },
      {
        name: 'Remodel & DIY',
        icon: 'icon-liteDIY_icon',
        route: 'search-result/hashtag/remodel&diy'
      },
      {
        name: 'Business & Real Estate',
        icon: 'icon-liteteam',
        route: 'search-result/hashtag/business&realestate'
      },
      {
        name: 'Pets & Animals',
        icon: 'icon-litepets-animals',
        route: 'search-result/hashtag/Pets & Animals'
      },
      {
        name: 'Fitness',
        icon: 'icon-liteFitness_Icon',
        route: 'search-result/hashtag/Fitness'
      },
      {
        name: 'Food & Recipes',
        icon: 'icon-litefoods',
        route: 'search-result/hashtag/food&recipes'
      },
      {
        name: 'Dance',
        icon: 'icon-litedance',
        route: 'search-result/hashtag/Dance'
      },
      {
        name: 'Faith & Spirituality',
        icon: 'icon-litereligion',
        route: 'search-result/hashtag/Faith & Spirituality'
      },
      {
        name: 'Art & Photography',
        icon: 'icon-liteart-photography',
        route: 'search-result/hashtag/Art & Photography'
      },
      {
        name: 'Kids & Family',
        icon: 'icon-liteKids-family',
        route: 'search-result/hashtag/Kids & Family'
      },
      {
        name: 'Gaming & eSports',
        icon: 'icon-litemobile-game',
        route: 'search-result/hashtag/Gaming & eSports'
      },
      {
        name: 'Automotive',
        icon: 'icon-liteautomotive',
        route: 'search-result/hashtag/Automotive'
      }
    ]
  }
};


export const ADVERTISEMENT_CONST= {
    ADVERTISEMENT: 'Advertisement',
    ADVERTISEMENT_LOGIN: 'Advertiser Log In',
    GET_STARTED: 'GET STARTED',
    HOME_TABS: ['follow', 'courses', 'discover', 'saved']
}